import { faQuoteLeft, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { QUOTE } from '../../../constants/props';
import Detail from '../../common/detail';

const useStyles = makeStyles({
  container: {
    marginLeft: '1.625rem',
  },
  quote: {
    fontSize: '1.5rem',
  },
});

const View = ({ author, position, company, comment }) => {
  const classes = useStyles();
  return (
    <Detail
      icon={<FontAwesomeIcon icon={faUser} />}
      title={author}
      subtitle={`${position} | ${company}`}
      detail={
        <Grid item className={classes.container} spacing={2} container>
          <Grid item>
            <FontAwesomeIcon className={classes.quote} icon={faQuoteLeft} />
          </Grid>
          <Grid item xs>
            <Typography>{comment}</Typography>
          </Grid>
        </Grid>
      }
    />
  );
};

View.propTypes = {
  QUOTE,
};

export default View;
